import Immutable from 'immutable'

import cachedFunction from '../cachedFunction'

export default cachedFunction(function calculateTreeLines(tree) {
  function recursion(nodes, higherTreeLines) {
    return nodes.map((node, index) => {
      const currentTreeLineSegment = index < nodes.count() - 1 ? '├' : '└'
      const childrenTreeLineSegmentPrefix = higherTreeLines.push(index < nodes.count() - 1 ? '│' : ' ')
      return node
        .set('__treeLines', higherTreeLines.push(currentTreeLineSegment))
        .update('children', (c) => recursion(c, childrenTreeLineSegmentPrefix))
    })
  }

  return recursion(tree, new Immutable.List())
})
